import { registerPlugin } from '@capacitor/core';

export interface ViewTreeEntry {
  depth: number;
  class: string;
  tag?: string;
  desc?: string;
  visible: boolean;
}

export interface HideMyLocationButtonResult {
  /** False when the button was not found — it then simply stays visible. */
  hidden: boolean;
  /** Which matcher succeeded: 'tag' or 'contentDescription'. */
  matchedBy?: string;
  reason?: string;
  /** View tree, reported only when the button was not found. */
  tree?: ViewTreeEntry[];
}

export interface MapUiTweaksPlugin {
  hideMyLocationButton(): Promise<HideMyLocationButtonResult>;
}

/**
 * Android-only companion to the map: @capacitor/google-maps enables the live
 * location dot and the Maps SDK's own "My Location" button with one flag, and
 * this app ships its own styled "My position" control instead.
 *
 * Implemented in android/app/src/main/java/.../MapUiTweaksPlugin.java.
 */
export const MapUiTweaks = registerPlugin<MapUiTweaksPlugin>('MapUiTweaks');
